/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import ItemCreateForm from '@/components/ItemCreateForm/index.vue';
import {UgcItemInterface} from '@/store/modules/ugc-item/types';
import {UgcBuildInterface} from '@/store/modules/ugc-build/types';


const namespace: string = 'ugcBuildModule';

/**
 * Build item create form component.
 *
 * This represents a list of user items that have been added to the system.  It extends the item create form and
 * adds the additional select item information to the build interface.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-build-item-create-form',
})
export default class BuildItemCreateForm extends ItemCreateForm {
    @Getter('item', {namespace}) public item!: UgcItemInterface;
    public build!: UgcBuildInterface;

    /**
     * Created lifecycle event.
     */
    public created(): void {
        if (!this.item) {
            return;
        }

        // merge data from item into new build object
        this.build.itemId = this.item.id;
        this.build.name = this.item.name;
        this.build.description = this.item.description;
        this.build.price = this.item.price;
        this.build.runningCost = this.item.runningCost;
        this.build.placementSound = this.item.placementSound;
        this.build.placementSoundSize = this.item.placementSoundSize;
        this.build.category = this.item.category;
        this.build.theme = this.item.theme;
        this.build.flexicolorOne = this.item.flexicolorOne;
        this.build.flexicolorTwo = this.item.flexicolorTwo;
        this.build.flexicolorThree = this.item.flexicolorThree;
        this.build.flexicolorFour = this.item.flexicolorFour;
        this.build.sceneryType = this.item.sceneryType;
        this.build.useLastImage = !!this.item.imgUuid;
    }

    /**
     * Cancel the form.
     */
    public cancel(): void {
        this.$router.push({name: 'item-show', params: {itemId: this.item.id}});
    }

}

